import { IReportsRepository } from "../../repositories/reports_repository";
import { IGetReportCadastroFuncionarioUseCase } from "../../../presentation/useCases/read/get_report_cadastro_funcionario_use_case";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";

import dayjs from "dayjs";
import { ReportData } from "../../models/report_data";

/**
 * GetReportCadastroFuncionarioUseCase
 */

export class GetReportCadastroFuncionarioUseCase implements IGetReportCadastroFuncionarioUseCase {
  constructor(
    private readonly repository: IReportsRepository,
  ) { }

  async getReportCadastroFuncionario(
    requiredMimeType: ReportMimeType | null,
    idFuncionario: number,
  ): Promise<ReportData> {
    const response = await this.repository.getRelatorioCadastroFuncionario(
      requiredMimeType,
      idFuncionario,
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `cadastro_funcionario_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}